import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { NumberishId } from "../../../model/type";
import { OfferMedium } from "../../../model/OfferMedium";
import RecordsWithParams from "../../../model/RecordsWithParams";
import { DataQueryParamsInterface } from "../../../model/DataQueryParams";
import { OfferCreatorFilterParams } from "../../../model/filter-params/OfferCreatorFilterParams";

export class Endpoint extends ApiEndpoint {
    public get = (offerId: NumberishId, params: DataQueryParamsInterface<OfferCreatorFilterParams>, cancelable: boolean = true): Promise<AxiosResponse<RecordsWithParams<OfferMedium>>> => {
        return this.connection.get('/offers/' + offerId + '/mediums', { extra: { dataQueryParams: params, cancelable } });
    }
}
